import axios from "axios";
import { Messages as Message } from "../../UI";
import { getCookieVal } from "../../tool/index";
import router from "../../router";
import store from "@/store";

const service = axios.create({
  baseURL: process.env.VUE_APP_API,
  withCredentials: false,
  timeout: 0,
});

let notToken = [ // 不需要token接口
  '/account-admin/login/login',
  '/account-admin/login/phone',
  '/user-service/user/createPersonSpace',
  '/account-admin/revise/phoneSignup',
  '/account-admin/revise/phoneCaptcha',
  '/user-service/user/getUserPrincipal',
  '/account-admin/login/imageCode',
  '/account-admin/wechat/callback',
  '/account-admin/revise/loginPhoneBinding',
  '/account-admin/revise/updatePassword',
  '/account-admin/login/getToken',
  '/account-admin/login/imageCode/check',
  '/account-search/basic/dict/getByKeys',
  '/account-search/basic/city/list',
  '/account-admin/wechat/qrcode?type=login',
  '/account-admin/wechat/polling',
  '/account-admin/wechat/loginPhoneBinding'
]

// 微信相关内部iframe不提示接口

// 默认请求头配置
service.defaults.headers.post["Content-Type"] = "application/json";

// 存储axios请求取消函数的标识集合
let pending = [];
let cancelToken = axios.CancelToken;
let removePending = (config) => {
  // console.log(config);
  for (let i in pending) {
    // if (pending[i].url === axios.defaults.baseURL + config.url) { //在当前请求在数组中存在时执行取消函数
    if (pending[i].url === config.url) {
      //在当前请求在数组中存在时执行取消函数
      pending[i].f(); //执行取消操作
      pending.splice(i, 1); // 根据具体情况决定是否在这里就把pending去掉
    }
  }
};

// 请求拦截
service.interceptors.request.use((config) => {
  removePending(config);
  config.cancelToken = new cancelToken(function executor(c) {
    //本次axios请求的配置添加cancelToken
    pending.push({
      url: config.url,
      // url: axios.defaults.baseURL + config.url,
      f: c,
    });
  });
  // if (config.method === 'post') {
  //   addParams(config);
  // }
  // if (config.url === '/user-service/user/getUserPrincipal') {
  //   config.headers['token'] = config.data;
  //   config.data = {}
  // } else {
  if (!notToken.includes(config.url)) {
    config.headers["token"] = getCookieVal("iyuanwu_token") || store?.state?.token;
  }
  // }
  return config;
});

// 响应拦截
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    const { code } = res;
    switch (Number(code)) {
      case 1:
      case 413: // 供应链token：该组织机构未开通供应链
        return Promise.resolve(res);
      case 0:
        if (response.config.url)
          Message.error({
            message: "操作失败，请稍后重试",
          });
        break;
      case 2:
        if (
          response.config.url.indexOf(
            "/account-admin/wechat/binding/callback"
          ) < 0
        ) {
          Message.error({
            message: res.message,
          });
        }
        return Promise.reject(res);
      case 402: // AccessToken无效
      case 403: // AccessToken已过期
      case 405: // RefreshToken无效或已过期
        Message.error({
          message: res.message,
        });
        router.push("/");
        break;
      case 409: // 当前账号未关联主体信息
      case 410: // 当前账号未选择主体
      case 411: // 当前账号主体被删除
      case 412: // 当前账号主体被禁用
        return Promise.resolve(res);
      default:
        Message.error({
          message: res.message,
        });
        return Promise.reject(res);
    }
  },
  (error) => {
    // 处理响应失败
    let msg = error.response
      ? error.response?.data?.message + error.response.status
      : "系统错误" + error;
    Message.error({
      message: msg,
    });
    return Promise.reject(error);
  }
);

export default service;
